import type { AnyAction } from 'redux';

import { EReduxTypes } from 'ts/enums/redux.types';

export const setSseMessage = (message: any): AnyAction => {
  return {
    type: EReduxTypes.SET_SSE_MESSAGE,
    data: message
  };
};

export const setSseFileToDownload = (message: any): AnyAction => {
  return {
    type: EReduxTypes.SET_SSE_FILE_TO_DOWNLOAD,
    data: message
  };
};
